// @flow

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ScaleMedia from './ScaleMedia';

class ScalableMedia extends PureComponent {
  static defaultProps = {
    children: '',
    className: '',
  };

  static propTypes = {
    children: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.media = [];
  }

  componentDidMount() {
    this.setupMedia();
  }

  componentDidUpdate() {
    this.setupMedia();
  }

  componentWillUnmount() {
    if (this.media.length) {
      this.media = [];
      global.removeEventListener('resize', this.resizeMedia.bind(this));
    }
  }

  setupMedia() {
    if ('objectFit' in global.document.documentElement.style === false) {
      const media = this.div.querySelectorAll('img, video');

      if (media.length) {
        this.media = [];
        for (let i = 0; i < media.length; i += 1) {
          this.media[i] = new ScaleMedia(media[i]);
        }

        global.addEventListener('resize', this.resizeMedia.bind(this));
      }
    }
  }

  resizeMedia() {
    if (this.media.length) {
      for (let i = 0; i < this.media.length; i += 1) {
        this.media[i].resize();
      }
    }
  }

  /* eslint-disable react/no-danger */
  render() {
    return (
      <div
        ref={ref => {
          this.div = ref;
        }}
        className={this.props.className}
        dangerouslySetInnerHTML={{ __html: this.props.children }}
      />
    );
  }
  /* eslint-enable react/no-danger */
}

export default ScalableMedia;



// WEBPACK FOOTER //
// ./screens/App/components/ScalableMedia/index.js